/** Cycle lifetime policy taken from the contract rate. */
export const CYCLE_KIND_COLORS: Record<string, string> = {
  rolling: 'blue',
  calendar: 'purple',
};

/**
 * Window state derived server-side. `pending` has no end yet (the generation
 * has not crossed the min threshold), `active` counts down to `expires_at`,
 * `closed` defers to its close reason.
 */
export const CYCLE_STATUS_COLORS: Record<string, string> = {
  pending: 'gold',
  active: 'green',
  closed: 'default',
};

/** Why a coverage layer stopped accumulating. */
export const CYCLE_CLOSE_REASON_COLORS: Record<string, string> = {
  expired: 'default',
  rate_changed: 'orange',
};

/**
 * Where a royalty report stands with the publisher. `draft` and `skipped` stay
 * grey — neither is an outcome the publisher has seen.
 */
export const ROYALTY_REPORT_STATUS_COLORS: Record<string, string> = {
  draft: 'default',
  sent: 'blue',
  skipped: 'default',
  approved: 'green',
  rejected: 'red',
};
